import { ReactComponent as Logo } from '../../assets/icons/LogoHeader.svg';
import styles from './InternalHeader.module.css';
import { MAIN_PAGE } from '../../router/paths';
import Icon from '../Icon';

type InternalHeaderProps = {
  title: string;
  onClose: () => void;
  flatInfo?: string;
};

export default function InternalHeader({ title, onClose, flatInfo }: InternalHeaderProps) {
  return (
    <header className={styles.wrapper}>
      <div className={styles.logo}>
        <a href={MAIN_PAGE} className={styles.logo_link}>
          <Logo width="62" height="25" className={styles.logo_icon} />
        </a>
        {flatInfo && (
          <>
            <div className={styles.separator}></div>
            <p className='text_body_b3'>{flatInfo}</p>
          </>
        )}
      </div>

      <div className={styles.naming}>
        <p
          className='text_body_b3'
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>

      <Icon
        name="closeIcon"
        onClick={onClose}
        width='12'
        height='12'
        className={styles.close_button}
      />
    </header>
  );
}